/**
 * Credit Card Plans Data
 * 
 * Contains all plan information for the three credit card options.
 */

export const PLANS = [
  {
    id: 'basis',
    name: 'Basis Plan',
    badge: 'BASIS',
    badgeClass: 'basis',
    creditRange: '€500 - €10.000',
    duration: '3 - 60 Monate',
    fee: '€197',
    lastFourDigits: '1234',
    featured: false,
    cardBackground: '',
    chipGold: false
  },
  {
    id: 'premium',
    name: 'Premium Plan',
    badge: 'PREMIUM',
    badgeClass: 'premium',
    creditRange: '€10.000 - €50.000',
    duration: '12 - 120 Monate',
    fee: '€394',
    lastFourDigits: '5678',
    featured: true,
    cardBackground: 'premium-bg',
    chipGold: false
  },
  {
    id: 'elite',
    name: 'Elite Plan',
    badge: 'ELITE',
    badgeClass: 'elite',
    creditRange: '€50.000 - €100.000',
    duration: '12 - 300 Monate',
    fee: '€788',
    lastFourDigits: '9012',
    featured: false,
    cardBackground: 'elite-bg',
    chipGold: true,
    isInfinite: true
  }
]
